function HelpLogo() {
  return (
    <svg
      width={44}
      height={35}
      viewBox="0 0 44 35"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <filter
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
          filterUnits="objectBoundingBox"
          id="prefix__a"
        >
          <feOffset
            dx={-3}
            dy={1}
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.114102129 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <filter
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
          filterUnits="objectBoundingBox"
          id="prefix__c"
        >
          <feOffset
            dx={2}
            dy={1}
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <path
          d="M18 17.564c0-4.423 3.548-8.537 7.917-9.188l3.595-.536 3.347.51c4.37.666 7.912 4.785 7.912 9.214v1.157c0 4.423-3.571 8.357-7.97 8.787l-3.416.333-5.18 5.316V26.73C20.779 26.73 18 23.15 18 18.72v-1.157z"
          id="prefix__b"
        />
        <path
          d="M2 5.604c2.948-4.838 5.745-5 10.266-5 4.52 0 7.54 0 11.5 5 3.959 5 2.506 11.478 0 13.925-2.507 2.448-8.4 3.632-8.4 3.632l-6.081 7.545v-7.545s-5.06 0-7.285-3.632C-.225 15.897-.948 10.441 2 5.604z"
          id="prefix__d"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="matrix(-1 0 0 1 58.77 0)">
          <use fill="#000" filter="url(#prefix__a)" xlinkHref="#prefix__b" />
          <use fill="#38D6D5" xlinkHref="#prefix__b" />
        </g>
        <g>
          <use fill="#000" filter="url(#prefix__c)" xlinkHref="#prefix__d" />
          <use fill="#4EE7E6" xlinkHref="#prefix__d" />
        </g>
      </g>
    </svg>
  )
}

export default HelpLogo
